import type { FillLayerSpecification, LineLayerSpecification } from 'mapbox-gl';

export const PENDING_FEMA_COLOR = '#b7791f';

export function pendingFemaLabel(date?: string | null): string {
  const parsed = date && /^\d{4}-\d{2}-\d{2}$/.test(date) ? new Date(`${date}T00:00:00Z`) : null;
  const display = parsed && Number.isFinite(parsed.getTime())
    ? parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
    : null;
  return display ? `Pending FEMA · effective ${display}` : 'Pending FEMA · effective date unavailable';
}

export function pendingFemaLabels(fc: GeoJSON.FeatureCollection): string[] {
  return [...new Set(fc.features.filter(f => f.properties?.source === 'fema_pending')
    .map(f => pendingFemaLabel(f.properties?.effective_date)))];
}

export function pendingFloodLayers(source: string, fillId: string, lineId: string): [FillLayerSpecification, LineLayerSpecification] {
  return [
    { id: fillId, source, type: 'fill', paint: { 'fill-color': PENDING_FEMA_COLOR,
      'fill-opacity': ['case', ['==', ['get', 'flood_type'], '500yr'], 0.1, 0.22] } },
    { id: lineId, source, type: 'line', paint: { 'line-color': PENDING_FEMA_COLOR,
      'line-width': 1.2, 'line-opacity': 0.85, 'line-dasharray': [3, 2] } },
  ];
}
